module.exports = __webpack_public_path__ + "static/media/icon_2.c2c07b13.png";